import * as actionType from 'ActionTypes';
import { updateObj } from 'Utils';

const initialState = {
	filter_data: [],
	selected_filter: {
		is_section: 0,
		is_verify: 0,
		has_video: 0,
		has_audio: 0,
		has_image: 0,
		from_date: '',
		to_date: '',
		categories: []
	},
	categories: [],
	has_filter: 0,
	selected_categories: [],
};

export const FilterReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionType.SET_FILTER_DATA:
			return updateObj(state, {
				filter_data: action.data
			});
		case actionType.SET_SELECTED_FILTER:
			return updateObj(state, {
				selected_filter: {
					...state.selected_filter,
					[action.filters.name]: action.filters.value
				}
			});
		case actionType.SET_HAS_FILTER:
			return updateObj(state, {
				has_filter: action.status
			});
		// case actionType.SET_HAS_FILES:
		// 	return updateObj(state, {
		// 		has_files: action.hasFiles
		// 	});
		case actionType.SET_CATEGORY:
			return updateObj(state, {
				categories: action.categories
			});
		case actionType.SET_SELECTED_CATEGORY:
			return updateObj(state, {
				selected_categories: action.categories
			});
		case actionType.RESET_FILTERS:
			return updateObj(state, {
				selected_filter: {
					...state.selected_filter,
					is_section: 0,
					is_verify: 0,
					has_video: 0,
					has_audio: 0,
					has_image: 0,
					from_date: '',
					to_date: '',
					categories: []
				}
			});
		default:
			return state;
	}
};
